import { Button, Checkbox, Fieldset, Group, Select, Stack, TextInput } from "@mantine/core";
import { DynamicForm, type DynamicFormRef } from '@/componets/DynamicComponent/dynamic.form.tsx';
import { useRef } from "react";
import { type ExitQuestion } from "@/testmeta.types";
export interface FinalPanelProps {
    onNext: (data: Record<string, any>) => void;
    questions: ExitQuestion[];
}

export default function FinalPanel(props: FinalPanelProps) {
    const formRef = useRef<DynamicFormRef>(null);
    
    return (<Stack>
        <Fieldset legend="Final Questions">
            <DynamicForm ref={formRef} components={props.questions} />
        </Fieldset>
        <Button onClick={() => {
            if (!formRef.current) return;
            const data = formRef.current.getValues();
            if (!data) {
                console.log('No data submitted');
                return;
            }
            props.onNext(data);
        }}>Submit</Button>
    </Stack>)
}